// Lib
import { get } from 'lodash';
import { FORM_ERROR } from 'final-form';

// Utils
import { isNetworkError } from '../../../common/error/errorUtil';
import globalLogger from '../../logger';

// Constants
import { RESPONSE_ERROR } from '../../../common/error/errorConstants';

const logger = globalLogger.createChannel('forms');

export default ({ form, reportError = true, sensitive }) =>
    (err) => {
        if (!err.response) {
            return {
                [FORM_ERROR]: {
                    message: get(err, 'message') || 'An unknown error occurred. Please try again or contact support.',
                    isNetworkError: isNetworkError(err),
                },
            };
        }

        const error = get(err, 'response.data.error');
        const isClientValidationError = error && error.code === RESPONSE_ERROR.VALIDATION_FAILURE;

        // Report form submission failure to Rollbar
        if (reportError && !isClientValidationError) {
            // Sensitive data audit: SAFE — warn/error auto-sanitized (error & response sanitized, PII keys redacted)
            logger.error('Failed to submit form', err, {
                form,
                response: err.response,
            });
        }

        const primaryError = {
            [FORM_ERROR]: {
                message: get(error, 'message') || 'Something went wrong, please try again',
                errorLocaleKey: error?.errorLocaleKey,
                context: error?.context,
                isNetworkError: isNetworkError(err),
                status: err.response?.status,
                code: error?.code,
            },
        };

        // On validation errors respond with a structure that the form can react to
        // Only show primary error message to the user if it is a form error
        if (isClientValidationError) {
            // For validation errors, preserve errorLocaleKey and context for each field
            const fieldErrors = {};
            if (error.details) {
                Object.keys(error.details).forEach(fieldName => {
                    const fieldError = error.details[fieldName];
                    if (fieldError) {
                        fieldErrors[fieldName] = {
                            ...fieldError,
                            errorLocaleKey: fieldError.errorLocaleKey,
                            context: fieldError.context,
                        };
                    }
                });
            }
            return {
                ...fieldErrors,
                ...(error.inner?.showPrimaryError ? primaryError : {}),
            };
        }

        return primaryError;
    };
